import { z } from 'zod'
import { orderManagementSearchSchema } from './list-model'

/** Which Tambah Pesanan flow is active: the manual form, or the AI chat paste. */
export const tambahPesananModeSchema = z.enum(['manual', 'ai'])
export type TambahPesananMode = z.infer<typeof tambahPesananModeSchema>

export const tambahPesananSearchSchema = z.object({
  mode: tambahPesananModeSchema.catch('manual').default('manual'),
  returnTo: z.enum(['dashboard', 'orders']).catch('dashboard').default('dashboard'),
  returnSearch: orderManagementSearchSchema.optional().catch(undefined),
})

export type TambahPesananSearch = z.infer<typeof tambahPesananSearchSchema>
